<template lang="pug">
v-app
  k-container
    v-row(justify="center")
      v-col(sm="6")
        k-card
          v-card-title(v-if="!is404Error").error
            h1.display-1.white--text Oh no a bug :(
          k-card-text
            template(v-if="!is404Error")
              p.paragraph.
                We have logged your error, thanks for your patience. In the near future you’ll be able to enjoy all parts of the Kintell
                community, without the bugs :)
            template(v-else)
              h2.headline {{ message }}
              p.paragraph.pt-12 Uh oh, we can’t seem to find the page you’re looking for. Try going back to previous page or #[nuxt-link(to="/get-in-touch").link--underline contact us] for more information.
            .mt-4
              k-button(v-if="!userIsAuthenticated" data-test-id="sign-in-button" to="/sign-in" color="primary" block) Sign in
              k-button(v-else href="/my-kintell/dashboard" color="primary" block) take me to my dashboard
          k-card-text(v-if="isDev")
            p.label Dev Only - Error Message
            code.d-block.pa-12 {{ error }}
          v-img(:src="images.personChattingOnLaptop" height="134" width="164")
</template>

<script>
import { UsesAuthenticatedUser } from '@/mixins'
export default {
  mixins: [
    UsesAuthenticatedUser
  ],
  props: {
    error: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      images: {
        personChattingOnLaptop: require('~images/person-chatting-on-laptop.svg')
      },
      isDev: process.env.NODE_ENV !== 'production'
    }
  },
  computed: {
    is404Error () {
      return this.statusCode === 404
    },
    statusCode () {
      return (this.error ? this.error.statusCode : 'Client Error')
    },
    message () {
      return this.error.message
    }
  },
  head () {
    return {
      title: 'Kintell | ' + this.statusCode + ' Error',
    }
  }
}
</script>
